import script from "./QuickpaySettingsPaymentPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickpaySettingsPaymentPartners.vue?vue&type=script&setup=true&lang=js"

import "./QuickpaySettingsPaymentPartners.vue?vue&type=style&index=0&id=5963725d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5963725d"]])

export default __exports__